module.exports = __webpack_public_path__ + "static/media/old-west--alumni.8dcf13c0.jpg";